export default __webpack_public_path__ + "images/drt_efb6ec.svg";